export enum FIRESTORE_COLLECTIONS {
	USER_COLLECTION = "users",
	EVENTS_COLLECTION = "events",
	QUESTIONNAIRES_COLLECTION = "questionnaires",
}
